import React, { useLayoutEffect, useRef } from "react";
import {
  shopByCollectionImg1,
  shopByCollectionImg2,
  shopByCollectionImg3,
  shopByCollectionImg4,
  curatedBlockImg1,
  curatedBlockImg2,
  curatedBlockImg3,
  curatedBlockImg4,
  RightArrow,
} from "../../../assets";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import ScrollTrigger from "gsap/ScrollTrigger";
import { Link } from "react-router-dom";
gsap.registerPlugin(ScrollTrigger);
function ShopByCollectionBlock({ homeData }) {
  const container = useRef();
  const mediaQuery = gsap.matchMedia();
  // useGSAP(() => {
  // useLayoutEffect(() => {
  //   mediaQuery.add("(min-width: 1024px)", () => {
  //     ScrollTrigger.create({
  //       trigger: ".shop-by-collection",
  //       start: "top top",
  //       end: "bottom+=1100 bottom",
  //       scrub: 0.5,
  //       pin: true,
  //     });
  //     ScrollTrigger.create({
  //       trigger: ".shop-by-collection",
  //       start: "center center",
  //       end: "bottom center",
  //       animation: gsap
  //         .timeline({
  //           paused: true,
  //         })
  //         .from(".text-1", {
  //           scale: 0.3,
  //           opacity: 0,
  //         })
  //         .to(".text-1", {
  //           top: "20%",
  //           scale: 0.8,
  //         }),
  //       scrub: 0.5,
  //     });
  //     ScrollTrigger.create({
  //       trigger: ".shop-by-collection",
  //       start: "center center",
  //       end: "bottom+=500 center",
  //       animation: gsap
  //         .timeline({
  //           paused: true,
  //         })
  //         .from(".scroll-down-circle", {
  //           y: 100,
  //           opacity: 0,
  //         })
  //         .to(".scroll-down-circle", {
  //           opacity: 0,
  //         })
  //         .from(".shop-by-cards", {
  //           y: "150%",
  //         })
  //         .to(".shop-by-card-1", {
  //           //empty to sync with the timeline
  //           // rotate: 90,
  //         }),
  //       scrub: 0.5,
  //     });
  //     ScrollTrigger.create({
  //       trigger: ".shop-by-collection",
  //       start: "center center",
  //       end: "bottom+=500 center",
  //       animation: gsap
  //         .timeline({
  //           paused: true,
  //         })
  //         .from(".shop-by-card-1", {
  //           rotate: -20,
  //           x: "160%",
  //         })
  //         .from(".shop-by-card-1", {
  //           rotate: -20,
  //           x: "160%",
  //         })
  //         .from(".shop-by-card-1", {
  //           rotate: -20,
  //           x: "160%",
  //         })
  //         .to(".shop-by-card-1", {
  //           rotate: 0,
  //           x: "0%",
  //         }),
  //       scrub: 0.5,
  //     });
  //     ScrollTrigger.create({
  //       trigger: ".shop-by-collection",
  //       start: "center center",
  //       end: "bottom+=500 center",
  //       animation: gsap
  //         .timeline({
  //           paused: true,
  //         })
  //         .from(".shop-by-card-2", {
  //           rotate: -10,
  //           x: "60%",
  //         })
  //         .from(".shop-by-card-2", {
  //           rotate: -10,
  //           x: "60%",
  //         })
  //         .from(".shop-by-card-2", {
  //           rotate: -10,
  //           x: "60%",
  //         })
  //         .to(".shop-by-card-2", {
  //           rotate: 0,
  //           x: "0%",
  //         }),
  //       scrub: 0.5,
  //     });
  //     ScrollTrigger.create({
  //       trigger: ".shop-by-collection",
  //       start: "center center",
  //       end: "bottom+=500 center",
  //       animation: gsap
  //         .timeline({
  //           paused: true,
  //         })
  //         .from(".shop-by-card-3", {
  //           rotate: 0,
  //           x: "-50%",
  //         })
  //         .from(".shop-by-card-3", {
  //           rotate: 0,
  //           x: "-50%",
  //         })
  //         .from(".shop-by-card-3", {
  //           rotate: 0,
  //           x: "-50%",
  //         })
  //         .to(".shop-by-card-3", {
  //           rotate: 0,
  //           x: "0%",
  //         }),
  //       scrub: 0.5,
  //     });
  //     ScrollTrigger.create({
  //       trigger: ".shop-by-collection",
  //       start: "center center",
  //       end: "bottom+=500 center",
  //       animation: gsap
  //         .timeline({
  //           paused: true,
  //         })
  //         .from(".shop-by-card-4", {
  //           rotate: 10,
  //           x: "-150%",
  //         })
  //         .from(".shop-by-card-4", {
  //           rotate: 10,
  //           x: "-150%",
  //         })
  //         .from(".shop-by-card-4", {
  //           rotate: 10,
  //           x: "-150%",
  //         })
  //         .to(".shop-by-card-4", {
  //           rotate: 0,
  //           x: "0%",
  //         }),
  //       scrub: 0.5,
  //     });
  //   }); //match media query end
  // }, []);
  // });
  return (
    <div>
      <div
        className="h-fit bg-primary py-10 px-4 shop-by-collection relative hidden lg:block mt-12"
        ref={container}
      >
        {/* <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-1">
          <div className="text-bg_1 text-5xl text-center tracking-[2.65px] my-4 cormorant-medium">
            BROWSE OUR BEST
          </div>
          <div className="text-bg_1 text-5xl tracking-[2.65px] text-center  my-4 mb-14 cormorant-medium">
            CURATED COLLLECTION
          </div>
        </div> */}
        {/* <div
          className="scroll-down-circle text-white border border-white inline-flex flex-col justify-between items-center rounded-full aspect-square w-[100px]
        absolute left-1/2 bottom-6 -translate-x-1/2"
        >
          <div className="h-[15px] border-r-[1px] "></div>
          <div className="inline-flex flex-col justify-between items-center text-xs lato-regular">
            <div>SCROLL</div>
            <div>DOWN</div>
          </div>
          <div className="h-[15px] border-r-[1px] "></div>
        </div> */}
        {/* <div className="shop-by-cards absolute top-[60%] left-1/2 -translate-x-1/2 -translate-y-1/2 w-full p-8"> */}
        <div className="text-bg_1 text-3xl lg:text-4xl text-center uppercase  my-2 mt-10 cormorant-medium pb-12">
          {homeData?.hashSection?.title}
        </div>
        <div className="shop-by-cards w-full p-8">
          <div className=" flex gap-6">
            <Link
              to={homeData?.hashSection?.slider[0]?.redirects}
              className="relative z-[1] origin-bottom bg-gradient-to-tr from-white to-[#ffffff9e] rounded-xl group shop-by-card-1"
            >
              <div className="relative p-4">
                <div className="aspect-[1/1] object-cover">
                  <img
                    src={homeData?.hashSection?.slider[0]?.image}
                    alt="bangale-1"
                    className="w-full h-full object-cover rounded-xl"
                  />
                </div>
              </div>
              <div className="mb-4 flex flex-row flex-grow justify-center items-center ">
                <div className="lato-regular flex items-center text-[#1C1919] py-2 pl-3 pr-3 text-[10px] sm:pl-8 sm:pr-8 sm:text-[16px] md:pl-4 md:pr-4 md:text-[12px] lg:pl-4 lg:pr-4 lg:text-[16px] xl:pl-5 xl:pr-5 xl:text-[18px] rounded-full font-medium transition-all duration-500 ">
                  <span className="text-xl me-1 font-bold">#</span>
                  {homeData?.hashSection?.slider[0]?.name}
                </div>
              </div>
            </Link>
            <Link
              to={homeData?.hashSection?.slider[1]?.redirects}
              className="relative z-[2] origin-bottom bg-gradient-to-tr from-white to-[#ffffff9e] rounded-xl group shop-by-card-2"
            >
              <div className="relative p-4">
                <div className="aspect-[1/1] object-cover">
                  <img
                    src={homeData?.hashSection?.slider[1]?.image}
                    alt="bangale-1"
                    className="w-full h-full object-cover rounded-xl"
                  />
                </div>
              </div>
              <div className="mb-4 flex flex-row flex-grow justify-center items-center ">
                <div className="lato-regular flex items-center text-[#1C1919] py-2 pl-3 pr-3 text-[10px] sm:pl-8 sm:pr-8 sm:text-[16px] md:pl-4 md:pr-4 md:text-[12px] lg:pl-4 lg:pr-4 lg:text-[16px] xl:pl-5 xl:pr-5 xl:text-[18px]  rounded-full font-medium transition-all duration-500 ">
                  <span className="text-xl me-1 font-bold">#</span>
                  {homeData?.hashSection?.slider[1]?.name}
                </div>
              </div>
            </Link>
            <Link
              to={homeData?.hashSection?.slider[2]?.redirects}
              className="relative z-[3] origin-bottom bg-gradient-to-tr from-white to-[#ffffff9e] rounded-xl group shop-by-card-3"
            >
              <div className="relative p-4">
                <div className="aspect-[1/1] object-cover">
                  <img
                    src={homeData?.hashSection?.slider[2]?.image}
                    alt="bangale-1"
                    className="w-full h-full object-cover rounded-xl"
                  />
                </div>
              </div>
              <div className="mb-4 flex flex-row flex-grow justify-center items-center ">
                <div className="lato-regular flex items-center text-[#1C1919] py-2 pl-3 pr-3 text-[10px] sm:pl-8 sm:pr-8 sm:text-[16px] md:pl-4 md:pr-4 md:text-[12px] lg:pl-4 lg:pr-4 lg:text-[16px] xl:pl-5 xl:pr-5 xl:text-[18px]  rounded-full font-medium transition-all duration-500 ">
                  <span className="text-xl me-1 font-bold">#</span>{homeData?.hashSection?.slider[2]?.name}
                </div>
              </div>
            </Link>
            <Link
              to={homeData?.hashSection?.slider[3]?.redirects}
              className="relative z-[4] origin-bottom bg-gradient-to-tr from-white to-[#ffffff9e] rounded-xl group shop-by-card-4"
            >
              <div className="relative p-4">
                <div className="aspect-[1/1] object-cover">
                  <img
                    src={homeData?.hashSection?.slider[3]?.image}
                    alt="bangale-1"
                    className="w-full h-full object-cover rounded-xl"
                  />
                </div>
              </div>
              <div className="mb-4 flex flex-row flex-grow justify-center items-center ">
                <div className="lato-regular text-[#1C1919] flex items-center py-2 pl-2 pr-2 text-[8px] sm:pl-8 sm:pr-8 sm:text-[16px] md:pl-4 md:pr-4 md:text-[12px] lg:pl-4 lg:pr-4 lg:text-[16px] xl:pl-5 xl:pr-5 xl:text-[18px]  rounded-full font-medium transition-all duration-500 ">
                  <span className="text-xl me-1 font-bold">#</span>
                  {homeData?.hashSection?.slider[3]?.name}
                </div>
              </div>
            </Link>
            {/* <div className="relative z-[4] origin-bottom bg-gradient-to-tr from-white to-[#ffffff9e] rounded-xl group shop-by-card-4">
              <div className="relative p-4">
                <div className="aspect-[1/1] object-cover">
                  <img
                    src={shopByCollectionImg1}
                    alt="bangale-1"
                    className="w-full h-full object-cover rounded-xl"
                  />
                </div>
              </div>
              <div className="mb-4 flex flex-row flex-grow justify-center items-center ">
                <div className="lato-regular text-[#1C1919] flex items-center py-2 pl-2 pr-2 text-[8px] sm:pl-8 sm:pr-8 sm:text-[16px] md:pl-4 md:pr-4 md:text-[12px] lg:pl-4 lg:pr-4 lg:text-[16px] xl:pl-5 xl:pr-5 xl:text-[18px]  rounded-full font-medium transition-all duration-500 ">
                  <span className="text-xl me-1 font-bold">#</span>COIN
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>

      <div className="lg:hidden bg-primary mt-12">
        <div className="p-4 pb-16">
          <div className="text-bg_1 text-4xl text-center  my-2 mt-10 cormorant-medium pb-12">
            Discover the Divine
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-4">
            <Link
              to={homeData?.hashSection?.slider[0]?.redirects}
              className="bg-gradient-to-tr from-white via-white to-[#FCF5F0] rounded-xl group"
            >
              <div className="relative">
                <img
                  src={homeData?.hashSection?.slider[0]?.image}
                  alt="bangale-1"
                  className="w-full h-auto pt-2 px-2 rounded-[16px]"
                />
              </div>
              <div className="pb-4 pt-4 flex flex-row flex-grow justify-center items-center ">
                <div className=" lato-regular flex items-center text-[#1C1919] py-2 pl-2 pr-2 sm:pl-8 sm:pr-8 text-[10px] md:text-[12px] text-nowrap whitespace-nowrap md:pl-3 md:pr-3 lg:pl-6 lg:pr-6  rounded-full font-medium transition-all duration-500 ">
                  <span className="text-sm me-1 font-bold">#</span>{homeData?.hashSection?.slider[0]?.name}
                </div>
              </div>
            </Link>
            <Link
              to={homeData?.hashSection?.slider[1]?.redirects}
              className="bg-gradient-to-tr from-white via-white to-[#FCF5F0] rounded-xl group"
            >
              <div className="relative">
                <img
                  src={homeData?.hashSection?.slider[1]?.image}
                  alt="bangale-1"
                  className="w-full h-auto pt-2 px-2 rounded-[16px]"
                />
              </div>
              <div className=" pb-4 pt-4 flex flex-row flex-grow justify-center items-center ">
                <div className=" lato-regular flex items-center text-[#1C1919] py-2 pl-2 pr-2 sm:pl-8 sm:pr-8 text-[10px] md:text-[12px] text-nowrap whitespace-nowrap md:pl-3 md:pr-3 lg:pl-6 lg:pr-6 rounded-full font-medium transition-all duration-500">
                  <span className="text-sm me-1 font-bold">#</span>{homeData?.hashSection?.slider[1]?.name}
                </div>
              </div>
            </Link>
            <Link
              to={homeData?.hashSection?.slider[2]?.redirects}
              className="bg-gradient-to-tr from-white via-white to-[#FCF5F0] rounded-xl group"
            >
              <div className="relative">
                <img
                  src={homeData?.hashSection?.slider[2]?.image}
                  alt="bangale-1"
                  className="w-full h-auto pt-2 px-2 rounded-[16px]"
                />
              </div>
              <div className=" pb-4 pt-4 flex flex-row flex-grow justify-center items-center ">
                <div className=" lato-regular flex items-center text-[#1C1919] py-2 pl-2 pr-2 sm:pl-8 sm:pr-8 text-[10px] md:text-[12px] text-nowrap whitespace-nowrap md:pl-3 md:pr-3 lg:pl-6 lg:pr-6 rounded-full font-medium transition-all duration-500">
                  <span className="text-sm me-1 font-bold">#</span>{homeData?.hashSection?.slider[2]?.name}
                </div>
              </div>
            </Link>
            <Link
              to={homeData?.hashSection?.slider[3]?.redirects}
              className="bg-gradient-to-tr from-[white] via-white to-[#FCF5F0] rounded-xl  group"
            >
              <div className="relative">
                <img
                  src={homeData?.hashSection?.slider[3]?.image}
                  alt="bangale-1"
                  className="w-full h-auto pt-2 px-2 rounded-[16px]"
                />
              </div>
              <div className="pb-4 pt-4 flex flex-row flex-grow justify-center items-center ">
                <div className=" lato-regular flex items-center text-[#1C1919] py-2 pl-2 pr-2 sm:pl-8 sm:pr-8 text-[10px] md:text-[12px] text-nowrap whitespace-nowrap md:pl-3 md:pr-3 lg:pl-6 lg:pr-6 rounded-full font-medium transition-all duration-500">
                  <span className="text-sm me-1 font-bold">#</span>{homeData?.hashSection?.slider[3]?.name}
                </div>
              </div>
            </Link>
            {/* <div className="bg-gradient-to-tr from-[white] via-white to-[#FCF5F0] rounded-xl  group">
              <div className="relative">
                <img
                  src={shopByCollectionImg1}
                  alt="bangale-1"
                  className="w-full h-auto pt-2 px-2 rounded-[16px]"
                />
              </div>
              <div className="pb-4 pt-4 flex flex-row flex-grow justify-center items-center ">
                <div className=" lato-regular flex items-center text-[#1C1919] py-2 pl-2 pr-2 sm:pl-8 sm:pr-8 text-[10px] md:text-[12px] text-nowrap whitespace-nowrap md:pl-3 md:pr-3 lg:pl-6 lg:pr-6 rounded-full font-medium transition-all duration-500">
                  <span className="text-sm me-1 font-bold">#</span>COIN
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ShopByCollectionBlock;
